import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.element.addEventListener('auto-complete:select', event => this.selectTemplate(event.detail.id))
    this.element.addEventListener('auto-complete:unselect', event => this.unselectTemplates())
    this.element.addEventListener('auto-complete:search', event => this.refreshData())
    this.element.addEventListener('auto-complete:change', event => this.refreshData())
  }

  selectTemplate(id) {
    this.unselectTemplates()
    const element = document.querySelector(`[data-support-template-id="${id}"]`)
    element.setAttribute('data-status', 'highlight')
    element.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }

  unselectTemplates = () =>  document.querySelectorAll(`[data-status]`).forEach(element => element.removeAttribute('data-status'))

  refreshData = () => document.querySelector('[data-support-template-form]').requestSubmit()
}